import { defineStore } from "pinia";
import { http, createInterceptor } from "~/lib/http";
import { API } from "~/constants/endpoints";
import { AxiosError } from "axios";

interface PostSignInResponse {
  data: {
    access_token: string;
  };
}

export const useAuthStore = defineStore(
  "authStore",
  () => {
    const token = ref<string | null>(null);
    const loading = ref<boolean>(false);
    const isAuthenticated = computed(() => !!token.value);

    watchEffect(() => createInterceptor(token.value));

    async function signin(email: string, password: string) {
      loading.value = true;

      try {
        const response = await http.post<PostSignInResponse>(API.PATH.SIGNIN, {
          email,
          password,
        });
        token.value = response.data.data.access_token;
        localStorage.removeItem("signOutMessage");
        //
      } catch (error) {
        token.value = null;

        if (error instanceof AxiosError) {
          throw createError({
            ...error,
            message: "Sign in failed",
            statusCode: error.response?.status,
          });
        }

        throw error;
        //
      } finally {
        loading.value = false;
      }
    }

    async function signout() {
      token.value = null;
    }

    return {
      token,
      loading,
      isAuthenticated,
      signin,
      signout,
    };
  },
  {
    persist: {
      storage: localStorage,
      paths: ["token"],
    },
  },
);
